/** Set document title and common SEO meta tags for marketing pages. */
export function setPageSeo({ title, description, image, canonical, type = "website" }) {
    if (title) document.title = title;

    const setMeta = (key, content, attr = "name") => {
        if (!content) return;
        let el = document.querySelector(`meta[${attr}="${key}"]`);
        if (!el) {
            el = document.createElement("meta");
            el.setAttribute(attr, key);
            document.head.appendChild(el);
        }
        el.setAttribute("content", content);
    };

    setMeta("description", description);
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", type, "property");
    if (image) setMeta("og:image", image, "property");
    setMeta("twitter:card", image ? "summary_large_image" : "summary");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
    if (image) setMeta("twitter:image", image);

    let link = document.querySelector("link[rel='canonical']");
    if (canonical) {
        if (!link) {
            link = document.createElement("link");
            link.rel = "canonical";
            document.head.appendChild(link);
        }
        link.href = canonical;
    } else if (link) {
        link.remove();
    }
}

export function formatBlogDate(iso) {
    if (!iso) return "";
    try {
        return new Date(iso).toLocaleDateString("en-IN", {
            day: "numeric",
            month: "long",
            year: "numeric",
        });
    } catch {
        return "";
    }
}
